// Copy plan configuration only. Ownership, dates and activity belong to the new plan.
export function createWorkoutPlanCopy(source, target) {
  if (!source || !source.splits || !Array.isArray(source.splits.workouts) || !source.splits.workouts.length) {
    throw new Error("WORKOUT_COPY_EMPTY")
  }
  if (!target || !target.user_id || !target.instructor_id) throw new Error("WORKOUT_COPY_TARGET_REQUIRED")

  const splits = JSON.parse(JSON.stringify(source.splits))
  splits.workouts.forEach((split) => {
    for (const key of ["_id", "creator", "creatorInfo", "createdAt", "updatedAt", "trainerGoalEdits"]) delete split[key]
  })
  return {
    title: source.title || source.splits.text || "Trainingsplan",
    picture: source.picture || null,
    duration: source.duration == null ? "" : source.duration,
    user_id: target.user_id,
    instructor_id: target.instructor_id,
    splits,
  }
}
